<template>
  <div
    class="pos-refund-container pos-container fullscreen"
    style="background-color: #ffffff"
  >
    <div class="pos-refund-wrapper">
      <header>{{ $tc("refund", 1) }} {{ $tc("fnb", 1) }}</header>
      <button @click="callClose()" class="btn-modal-close mt-3">&times;</button>

      <!-- SECTION 1 -->
      <div class="mt-5 pt-5" v-if="section.one">
        <div class="col-lg-6 col-xl-4 mx-auto text-center mb-5">
          <div class="input-fnb-order mb-4">
            <!-- <input
              v-model="order_id"
              type="text"
              id="fnbOrderId"
              required="required"
              placeholder="Order No."
            />
            <label>{{ $tc("order", 1) }} {{ $t("no") }}</label> -->
            <b-form-input
              v-debounce:500="onSearchOrder"
              v-model="searchValue"
              placeholder="Search Order Code, Email, Name, Mobile."
              class=""
              type="search"
              v-on:search="onSearchOrder"
              name="searchFnbOrders"
              id="searchFnbOrders"
              ref="searchFnbOrders"
              tabindex="0"
            ></b-form-input>
            <VkeyboardFloat
              :ID="'searchFnbOrders'"
              :onClickFun="
                () => {
                  Object.keys(keyboardsVisible).map((x) => {
                    if (x == 'showV1Keyboard') {
                      keyboardsVisible[x] = !keyboardsVisible[x];
                    } else {
                      keyboardsVisible[x] = false;
                    }
                  });
                }
              "
            />
            <Vkeyboard
              :inputName="'searchFnbOrders'"
              :showOrHide="keyboardsVisible.showV1Keyboard"
              :initialValue="searchValue"
              @onChangeEvent="() => {}"
              @onKeyEnter="onSearchOrder"
              @changeKeyboardInput="searchValue = $event"
              @onClickClose="
                () => {
                  keyboardsVisible.showV1Keyboard = false;
                }
              "
            />
          </div>

          <!-- <button v-on:click="show2()" class="btn-blue-lg">
            {{ $t("submit") }}
          </button> -->
        </div>
      </div>
      <div class="row" v-if="section.one && searchValue">
        <div class="col-8 mt-5 mx-auto">
          <table
            class="list-view-table mx-auto tableWidth"
            style="box-shadow: 0px 1px 5px -1px"
            v-if="searchResults.length > 0"
          >
            <thead>
              <tr class="bg-light">
                <th class="w-cell">Order Code</th>
                <th>Customer Details</th>
                <th>Amount</th>
                <th>Time</th>
                <th class="w-cell"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(order, orderIndex) in searchResults"
                :key="orderIndex"
              >
                <td class="font-weight-bold">
                  {{ order.order_code }}
                </td>
                <td class="font-weight-bold">
                  {{ order.cust_mobile ? order.cust_mobile : "-" }}&nbsp;<span
                    v-if="order.first_name"
                    >({{
                      order.first_name +
                        (order.last_name ? " " + order.last_name : "")
                    }})</span
                  >
                </td>
                 <td>
                  {{ order.ft_currency_name + " " + order.ft_total_amount }}
                </td>
                <td>{{ order.ft_date_time }}</td>
                <td class="text-center">
                  <b-button
                    variant="default"
                    class="btn-blue pay-btn"
                    @click="onSelectOrder(order)"
                    >{{ "Select" }}</b-button
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <table
            v-if="loading && searchResults.length == 0"
            class="list-view-table text-left mx-auto w-50 border"
            border="1"
          >
            <tbody>
              <tr>
                <td class="text-center" colspan="3">
                  <b-spinner
                    variant="dark"
                    label="Spinning"
                    class="translate-spinner"
                  ></b-spinner>
                </td>
              </tr>
            </tbody>
          </table>
          <table
            v-if="!loading && searchResults.length == 0"
            class="list-view-table text-left mx-auto w-50 border"
            border="1"
          >
            <tbody>
              <tr>
                <td class="text-center" colspan="3">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            @change="onChangePagination($event)"
            :per-page="limit"
            aria-controls="my-table"
            class="my-3"
            v-if="searchResults.length > 0"
          ></b-pagination>
        </div>
      </div>

      <!-- SECTION 2  -->
      <div class="content-fnb-refund pt-4" v-if="section.two">
        <div class="col-lg-8 col-xl-6 mx-auto mb-5">
          <div class="row">
            <div class="col-6 mb-4">
              <div class="input-material">
                <input
                  disabled
                  type="text"
                  :value="order_id"
                  required="required"
                />
                <label>{{ $tc("order", 1) }} {{ $t("no") }}</label>
              </div>
            </div>

            <div class="col-6 mb-4">
              <div class="dropdown-curve-container">
                <label :class="selectedPaymentObj ? 'shift-up' : ''"
                  >{{ $t("select") }} {{ $tc("refund", 2) }}
                  {{ $tc("mode", 2) }}</label
                >
                <multiselect
                  v-model="selectedPaymentObj"
                  @select="onSelectHandlerPayment($event, 'select')"
                  @remove="onSelectHandlerPayment($event, 'remove')"
                  placeholder=""
                  track-by="pm_id"
                  label="pm_payment_mode"
                  :options="paymentModes"
                  :multiple="false"
                ></multiselect>
              </div>
            </div>

            <div v-if="false" class="col-6 mb-4">
              <div class="input-material mb-4">
                <div class="dropdown-curve-container">
                  <label :class="selectedPayment.length > 0 ? 'shift-up' : ''"
                    >{{ $t("select") }} {{ $tc("refund", 2) }}
                    {{ $tc("mode", 2) }}</label
                  >
                  <div class="d-flex justify-content-center align-items-center">
                    <b-dropdown
                      :text="selectedPayment"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        href="#"
                        v-for="(item, itemIndex) in getPaymentTypesList"
                        :key="itemIndex"
                        v-on:click="onSelectHandlerPayment(item, 'select')"
                        >{{ item.pm_payment_mode }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <!-- <Tooltip :title="$t('vendorsCountry_tooltip')" />-->
                  </div>
                </div>
                <!-- <input type="text" :value="refund.rr_reason" required="required" disabled />
                <label>Ticket Refund Reason</label>-->
              </div>
            </div>
            <div class="col-12 mb-4">
              <div class="input-material">
                <input
                  type="text"
                  v-model="refund_reason"
                  required="required"
                  id="fnbRefundReason"
                  @focus="onClickInputHandler('showReasonKeyboard')"
                />
                <label>{{ "Enter Refund Reason" }}</label>
                <VkeyboardFloat
                  :ID="'fnbRefundReason'"
                  :onClickFun="
                    () => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if (x == 'showReasonKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'fnbRefundReason'"
                  :showOrHide="keyboardsVisible.showReasonKeyboard"
                  :initialValue="refund_reason"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="
                    () => {
                      keyboardsVisible.showReasonKeyboard = false;
                    }
                  "
                  @changeKeyboardInput="refund_reason = $event"
                  @onClickClose="
                    () => {
                      keyboardsVisible.showReasonKeyboard = false;
                    }
                  "
                />
              </div>
            </div>
            <div class="col-12 mb-4">
              <div class="dropdown-curve-container">
                <label
                  v-if="SelectedFnbItem && SelectedFnbItem.length > 0"
                  :class="
                    SelectedFnbItem && SelectedFnbItem.length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >{{ $t("select") }} {{ $tc("items", 2) }}</label
                >
                <multiselect
                  :disabled="ALLOW_PARTIAL_REFUND == 'N'"
                  v-model="SelectedFnbItem"
                  @select="onSelect($event)"
                  @remove="onRemove($event)"
                  placeholder="Select Item"
                  track-by="fst_id"
                  label="fst_item_name"
                  :options="OrderItems"
                  :multiple="true"
                ></multiselect>
              </div>
            </div>

            <div class="col-6 mb-4" v-if="isCashCardRefund">
              <div class="input-material">
                <input
                  type="search"
                  v-model="search_ccn"
                  name="cash_card_number"
                  id="cash_card_number"
                  v-debounce:500="onSearchCashCard"
                  v-on:search="onSearchCashCard"
                  placeholder="xxx-xxxxxxxx-x"
                  @focus="onClickInputHandler('showCashCardKeyboard')"
                  :class="{ invalid_input: cc_input_error }"
                />
                <label>{{ "Enter Cash Card Number" }}</label>
                <VkeyboardFloat
                  :ID="'cash_card_number'"
                  :onClickFun="
                    () => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if (x == 'showCashCardKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'cash_card_number'"
                  :showOrHide="keyboardsVisible.showCashCardKeyboard"
                  :initialValue="search_ccn"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="onSearchCashCard"
                  @changeKeyboardInput="search_ccn = $event"
                  @onClickClose="
                    () => {
                      keyboardsVisible.showCashCardKeyboard = false;
                    }
                  "
                />
              </div>
              <p class="error_message">
                <span v-if="cc_input_error">{{ cc_input_error }}</span>
              </p>
            </div>

            <div class="col-12 mb-4" v-if="showCashCardCustomer">
              <b-collapse v-model="showCashCardCustomer">
                <table
                  class="list-view-table border mb-0"
                  v-if="checkCustomer(cashCardsList[0])"
                >
                  <thead>
                    <tr>
                      <th>{{ $tc("card") }} {{ $tc("number") }}</th>
                      <th>{{ $tc("customer") }} {{ $tc("name") }}</th>
                      <th class="text-right">{{ $t("balance") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(card, key) in cashCardsList" :key="key">
                      <td>{{ card.cash_card_visible }}</td>
                      <td>
                        {{ getCardName(card) }}
                      </td>
                      <td class="text-right">
                        {{ currFormat(card.balance_amount) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table class="list-view-table border mb-0" v-else>
                  <thead>
                    <tr>
                      <th>{{ $tc("card") }} {{ $tc("number") }}</th>
                      <th class="text-center" colspan="2">
                        {{ $t("action") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(card, key) in cashCardsList" :key="key">
                      <td>{{ card.cash_card_visible }}</td>
                      <td class="p-3" colspan="2">
                        <div
                          class="
                            d-flex
                            align-items-center
                            justify-content-center
                          "
                        >
                          <b-form-radio
                            value="1"
                            class="j-radio"
                            v-model="cardSaleType"
                          >
                            <div>
                              <span>{{ $t("street_sale") }}</span>
                            </div>
                          </b-form-radio>
                          <strong class="mx-3">OR</strong>

                          <b-form-radio
                            value="2"
                            class="j-radio"
                            v-model="cardSaleType"
                          >
                            <div>
                              <span>{{ $t("add_customer_details") }}</span>
                            </div>
                          </b-form-radio>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-collapse>
            </div>

            <div class="col-4 mb-4">
              <div class="input-material">
                <input
                  type="text"
                  disabled
                  :value="`${currFormat(totalRefundAmount)} ${curr_code}`"
                  name="totalRefundAmount"
                  id="totalRefundAmount"
                />
                <label>{{ "Total Refund Amount" }}</label>
              </div>
              <p class="error_message"></p>
            </div>
            <div class="col-6 mb-4">
              <div
                class="d-flex align-items-center"
                @click="collapseObj.itemView = !collapseObj.itemView"
              >
                View Item Price Details &nbsp;<span
                  class="icon-question"
                ></span>
              </div>
            </div>
          </div>
          <div
            class="section-wrapper col-12 px-0"
            v-if="SelectedFnbItem.length > 0 || AlreadyRefunded.length > 0"
          >
            <div class="d-flex">
              <div
                class="
                  sectionName
                  bor
                  d-flex
                  justify-content-between
                  mb-2
                  col-12
                  align-items-center
                "
                v-if="false"
              >
                <div
                  class="fs-17 font-weight-bold pl-2 align-items-center"
                  @click="collapseObj.itemView = !collapseObj.itemView"
                >
                  <div class="">View Item Price Details</div>
                </div>
                <span
                  class="icon-collapse-up blue-icon mx-1 btn float-right"
                  style="height: 30px; cursor: pointer"
                  v-if="collapseObj.itemView"
                  @click="collapseObj.itemView = !collapseObj.itemView"
                ></span>
                <span
                  class="icon-collapse blue-icon mx-1 btn float-right"
                  style="height: 30px; cursor: pointer"
                  v-if="!collapseObj.itemView"
                  @click="collapseObj.itemView = !collapseObj.itemView"
                ></span>
              </div>
            </div>
            <b-collapse
              v-model="collapseObj.itemView"
              class="pt-3 px-2 bor mb-4 back collapse show"
            >
              <section class="row">
                <div
                  class="table-scroll w-100 mx-3 mb-3"
                  v-if="AlreadyRefunded.length > 0"
                >
                  <label class="font-weight-bold">Already Refunded</label>
                  <table class="swc-report-table" border="1">
                    <thead>
                      <tr>
                        <th class="bg-lightgrey p-1">ITEM NAME</th>
                        <th class="bg-lightgrey p-1">ITEM PRICE PAID</th>
                        <th class="bg-lightgrey p-1">REFUNDED AMOUNT</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, itemIndex) in AlreadyRefunded"
                        :key="itemIndex"
                      >
                        <td class="text-left">
                          {{ item.fst_quantity }} &nbsp;{{ item.fst_item_name }}
                        </td>
                        <td class="text-left">
                          {{ currFormat(item.fp_total_amount) }}
                        </td>
                        <td class="text-right">
                          <input
                            disabled
                            type="number"
                            step="any"
                            v-model="item.refunded_amount"
                            required="required"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="table-scroll w-100 mx-3 mb-3"
                  v-if="SelectedFnbItem.length > 0"
                >
                  <label class="font-weight-bold">Selected Items</label>
                  <table class="swc-report-table" border="1">
                    <thead>
                      <tr>
                        <th class="bg-lightgrey p-1">ITEM NAME</th>
                        <th class="bg-lightgrey p-1">ITEM PRICE PAID</th>
                        <th class="bg-lightgrey p-1" v-if="false">
                          REFUND AMOUNT
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, itemIndex) in SelectedFnbItem"
                        :key="itemIndex"
                      >
                        <td class="text-left">
                          {{ item.fst_quantity }} &nbsp;{{ item.fst_item_name }}
                        </td>
                        <td class="text-left">
                          {{ currFormat(item.fp_total_amount) }}
                        </td>
                        <td class="text-right" v-if="false">
                          <div class="input-material">
                            <input
                              disabled
                              type="text"
                              :id="`${itemIndex}_refund_amount`"
                              v-model="item.refunded_amount"
                              required="required"
                              @focus="onClickInputHandler('items', item)"
                            />
                            <label>{{ "Enter Refund amount" }}</label>
                            <VkeyboardFloat
                              :ID="`${itemIndex}_refund_amount`"
                              :onClickFun="
                                () => {
                                  SelectedFnbItem.map((y) => {
                                    if (item.item_id == y.item_id) {
                                      item.keyboardActive = true;
                                    } else {
                                      y['keyboardActive'] = false;
                                    }
                                  });
                                  Object.keys(keyboardsVisible).map((x) => {
                                    keyboardsVisible[x] = false;
                                  });
                                }
                              "
                            />
                            <Vkeyboard
                              :inputName="`${itemIndex}_refund_amount`"
                              :showOrHide="item.keyboardActive"
                              :initialValue="String(item.refunded_amount)"
                              :keyBoardType="'numeric'"
                              @onChangeEvent="() => {}"
                              @onKeyEnter="
                                () => {
                                  item.keyboardActive = false;
                                }
                              "
                              @changeKeyboardInput="
                                item.refunded_amount = $event
                              "
                              @onClickClose="
                                () => {
                                  item.keyboardActive = false;
                                }
                              "
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>
            </b-collapse>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <button
                class="btn btn-outline-blue btn-default"
                v-on:click="show1()"
              >
                {{ $t("cancel") }}
              </button>
              <button class="btn-blue" v-on:click="checkRefundPayMode()">
                {{
                  "Refund " + currFormat(totalRefundAmount) + ` ${curr_code}`
                }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="refund-center-content" v-if="section.three">
        <div class="col-lg-6 col-xl-4 mx-auto text-center mb-5">
          <div class="success-tick-wrapper">
            <span class="success-tick"></span>
            <div class="refund-text font-weight-bold mb-3">
              Refund Successfull.
            </div>
          </div>
          <button v-on:click="onClickHandler('FnbRefund')" class="btn-blue-lg">
            {{ $t("close") }}
          </button>
          <button
            v-if="checkPrintAvailable"
            v-on:click="onPrintHandler()"
            class="btn-blue-lg"
          >
            {{ $t("Print") }}
          </button>
        </div>
      </div>

      <b-modal
        id="confirmStockDeduction"
        title="Do You Want To Stock In Items Again?"
        hide-footer
        no-close-on-backdrop
      >
        <div class="pb-1">
          <!-- <p class="fs-16 mb-4">{{ `` }}</p> -->
          <table class="table tableItem">
            <thead>
              <tr>
                <th scope="col" style="white-space: nowrap;">Item Name</th>
                <th scope="col">Qty</th>
                <th scope="col" style="white-space: nowrap;">Add to Stock</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, Itemindex) in SelectedFnbItem">
                <template
                  v-if="
                    item &&
                      item.hasOwnProperty('combo_data') &&
                      item.combo_data &&
                      item.combo_data.length > 0
                  "
                >
                  <tr
                    v-for="(combo_item, ci_index) in item.combo_data"
                    :key="ci_index"
                  >
                    <td style="word-break:break-word;white-space:break-spaces;"
                      >{{ combo_item.item_name }}&nbsp;({{
                        item.fst_item_name
                      }})</td
                    >
                    <td>{{ combo_item.quantity }}</td>
                    <td>
                      <div class="d-flex align-items-center mx-4">
                        <b-form-checkbox
                          v-model="combo_item.reload_stock"
                          value="Y"
                          unchecked-value="N"
                          @change="onChangeStockReload($event, 'combo', Itemindex, ci_index)"
                          class="j-checkbox mb-1 pb-0"
                          name="check-button"
                        ></b-form-checkbox>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr :key="Itemindex">
                    <td
                      style="word-break:break-word;white-space:break-spaces;"
                      >{{ item.fst_item_name }}</td
                    >
                    <td>{{ item.fst_quantity }}</td>
                    <td>
                      <div class="d-flex align-items-center mx-4">
                        <b-form-checkbox
                          v-model="item.reload_stock"
                          value="Y"
                          @change="onChangeStockReload($event, 'item', Itemindex, null)"
                          unchecked-value="N"
                          class="j-checkbox mb-1 pb-0"
                          name="check-button"
                        ></b-form-checkbox>
                      </div>
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>

          <span class="mx-1"></span>
          <div class="text-center">
            <button
              class="btn btn-danger btn-danger-lg px-4 fs-14"
              :disabled="disableRefundBtn"
              :class="disableRefundBtn ? 'disableRefundBtn' : ''"
              @click.prevent.stop="checkRefundPayMode(true)"
            >
              Proceed
            </button>
          </div>
        </div>
      </b-modal>

      <b-modal
        id="processessingModal"
        ref="processessingModal"
        title="Change Password"
        hide-header
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        centered
        size="sm"
      >
        <div class="loader-wrapper text-center my-5">
          <div class="d-flex justify-content-center">
            <b-spinner
              small
              class="ml-1"
              :variant="'warning'"
              type="grow"
            ></b-spinner>
            <b-spinner
              class="ml-1"
              small
              :variant="'warning'"
              type="grow"
            ></b-spinner>
            <b-spinner
              class="ml-1"
              small
              :variant="'warning'"
              type="grow"
            ></b-spinner>
          </div>
          <h6 class="pt-3 mb-2">Please Wait...</h6>
        </div>
      </b-modal>

      <!-- cinemaManagerLoginPopup -->
      <b-modal
        id="cinemaManagerLoginPopup"
        ref="cinemaManagerLoginPopup"
        title="Change Password"
        hide-header
        hide-footer
      >
        <form>
          <button
            @click.prevent.stop="$bvModal.hide('cinemaManagerLoginPopup')"
            class="btn-modal-close pos-modal-close"
            style="position: absolute; right: 15px; top: 15px; z-index: 99"
          >
            &times;
          </button>
          <div class="row mb-2 mx-0">
            <div class="col-12">
              <div class="text-center mb-4 pb-2 mt-3">
                <h4>Cinema Manager Login</h4>
              </div>
              <div class="col-lg-10 mx-auto align-self-center">
                <div class>
                  <div class="mb-3">
                    <div class="input-material">
                      <input
                        type="text"
                        v-model="username"
                        name="username"
                        id="username"
                        v-validate="'required'"
                        placeholder="username"
                      />
                      <label>Cinema Manager Username</label>
                    </div>
                    <p class="error_message">
                      <span v-if="submitted && errors.has('username')">{{
                        errors.first("username")
                      }}</span>
                    </p>
                  </div>
                  <div class="input-material">
                    <input
                      type="password"
                      v-model="password"
                      name="password"
                      id="password"
                      v-validate="'required'"
                      placeholder="password"
                    />
                    <label>Cinema Manager Password</label>
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && errors.has('password')">{{
                      errors.first("password")
                    }}</span>
                  </p>
                  <div class="d-flex mt-3">
                    <button
                      @click.prevent.stop="
                        $bvModal.hide('cinemaManagerLoginPopup')
                      "
                      class="btn-white-lg w-50 mr-2"
                    >
                      Cancel
                    </button>
                    <button
                      @click.prevent.stop="CheckLogin"
                      class="btn-blue-lg w-50 ml-2"
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </b-modal>
    </div>
    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
    <AddCustomerDetailsPopup
      modalId="addcustmodalcashCard"
      :isRefundModal="true"
      :onHideModal="handleOnHideModal"
    />
    <ManagerAuthLogin
      :moduleName="'posFnbRefund'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'authManager_posFnbRefund'"
    />
  </div>
</template>

<script>
  import PosCashCalculator from "@/components/Partials/posCashCalculator";
  import PosService from "@/services/PosService.js";
  import PosFnbService from "@/services/PosFnbService";
  import MasterService from "@/services/MasterService.js";
  import UserService from "@/services/UserService.js";
  import { min } from "moment";
  import { mapState, mapGetters, mapActions } from "vuex";
  import _ from "lodash";
  import AddCustomerDetailsPopup from "@/components/Partials/AddCustomerDetailsPopup";
  import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
  import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
  import { generateRandomCode } from "@/helper/collection";
  import { BASEURL } from "@/config/index";
  import { CLIENT_NAME } from "@/helper/Role";
  import Printd from "printd";

  export default {
    props: {
      onClickHandler: { type: Function },
    },
    components: {
      PosCashCalculator,
      AddCustomerDetailsPopup,
      VkeyboardFloat,
      Vkeyboard,
      ManagerAuthLogin,
      NoRecords,
    },
    data() {
      return {
        disableRefundBtn: false,
        curr_code: "",
        collapseObj: {
          itemView: false,
        },
        neoleapCardDetails: {
          card_refund_details: null,
          nl_card_name: null,
          refund_card_payment_gateway: null,
        },
        EjsData: null,
        isReprint: false,
        card_payment_gateway: "",
        card_trx_details: "",
        neoPayType: 1,
        neo_orderRef: "",
        neo_ws: null,
        test_response: "",
        neo_retry_count: 0,
        machineDisplay: {
          displayText: "",
          status: true,
          processing: false,
        },

        noAuth: false,
        searchResults: [],
        searchValue: "",

        limit: 5,
        currentPage: 1,
        rows: 0,
        loading: false,

        keyboardsVisible: {
          showV1Keyboard: false,
          showReasonKeyboard: false,
          showAmountKeyboard: false,
          showCashCardKeyboard: false,
        },
        order_id: "",
        RefundReason: "",
        section: {
          one: true,
          two: false,
          three: false,
        },
        booking_id: "",
        refund: {
          sb_id: null,
          booking_id: null,
          enterRefundAmount: null,
          //
          booking_status_id: null,
          rr_reason: null,
          rr_id: null,
          payment_mode_id: null,
          //
          curr_code: null,
          sb_total_net_amount: null,
          sb_total_amount: null,
          sb_total_amount_paid: null,
          seat_amount_total: 0,
        },
        orginal_payment_mode: null,
        original_booking_source: null,
        username: "",
        password: "",
        submitted: false,
        Refunds: [],
        seats: [],
        Selectedseats: [],
        selectedPayment: "",
        offer_name: "",
        offer_price: 0,
        voucher_name: "",
        seatsArray: [],
        SelectedFnbItem: [],
        OrderItems: [],
        refund_payment_id: "",
        AlreadyRefunded: [],
        refund_reason: "",
        cinemaId: null,
        cashCardsList: [],
        search_ccn: "",
        cc_input_error: "",
        selectedPaymentObj: "",
        cashCardDetails: "",
        cardSaleType: 1, // 1 -> street sale AND 2 -> customer sale
      };
    },
    watch: {
      "machineDisplay.processing": function(newValue) {
        if (newValue) {
          this.$bvModal.show("processessingModal");
        } else {
          this.$bvModal.hide("processessingModal");
        }
      },
      cardSaleType(newval) {
        if (newval == 2) {
          this.$bvModal.show("addcustmodalcashCard");
        } else if (newval == 1) {
          this.resetCustomerDetails();
          this.MAKE_DATA_EMPTY();
        }
      },
    },
    computed: {
      ...mapGetters([
        "getPaymentTypesList",
        "getCustomerDetails",
        "MANAGER_AUTH_FOR_CHANGES",
        "USE_NEOLEAP_POS_PAYMENT",
        "NEOLEAP_WEBSOCKET_URL",
        "ALLOW_CINEMA_SPECIFIC_REFUND_ONLY",
        "ALLOW_PARTIAL_REFUND",
      ]),
      isCashCardRefund() {
        if (this.refund_payment_id == 11) {
          return true;
        } else {
          return false;
        }
      },
      totalRefundAmount() {
        let amount = 0;
        amount = this.SelectedFnbItem.reduce(
          (acc, { refunded_amount }) => acc + parseFloat(refunded_amount),
          0
        );
        return amount;
      },
      checkPrintAvailable() {
        return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME;
      },
      paymentModes() {
        let allowedPmIds = [];
        if (this.original_booking_source == 2) {
          //ONLINE BOOKING SOURCE
          if (this.orginal_payment_mode == 11) {
            // CASH CARD
            allowedPmIds.push(11);
          } else if (
            this.orginal_payment_mode != 12 &&
            this.orginal_payment_mode != 13
          ) {
            allowedPmIds.push(11);
          }
        } else if (
          this.original_booking_source == 1 ||
          this.original_booking_source == 5
        ) {
          // BOXOFFICE (1) / CONCESSION-FNB (5) booking source
          if (this.orginal_payment_mode == 1) {
            allowedPmIds.push(1, 11);
          } else if (this.orginal_payment_mode == 11) {
            allowedPmIds.push(11);
          } else if (
            this.orginal_payment_mode != 12 &&
            this.orginal_payment_mode != 13 &&
            (this.USE_NEOLEAP_POS_PAYMENT == "N" || (this.USE_NEOLEAP_POS_PAYMENT == "Y" && !["2", "3"].includes(String(this.orginal_payment_mode))))
          ) {
            allowedPmIds.push(1, 11);
          }
        }

        if (
          this.USE_NEOLEAP_POS_PAYMENT == "Y" &&
          ["2", "3"].includes(String(this.orginal_payment_mode))
        ) {
          allowedPmIds.push(2, 3);
        }

        // allowedPmIds.push(1);

        console.log("allowedPmIds", allowedPmIds);
        // [1, 2, 3, 11]
        const allowedSet = new Set(allowedPmIds.map((id) => String(id)));
        return this.getPaymentTypesList.filter((x) =>
          allowedSet.has(String(x.pm_id)),
        );
      },
      CashCardCustEmail() {
        return this.$store.getters.CashCardCustEmail;
      },
      showCashCardCustomer() {
        return this.cashCardsList.length > 0 ? true : false;
      },
    },
    beforeMount() {
      this.cinemaId = this.secureStore.get("USINFO").cinema_id;
    },
    methods: {
      ...mapActions([
        // FETCH FROM MASTER STORE
        "fetchPaymentTypesList",
        "resetCustomerDetails",
        "MAKE_DATA_EMPTY",
      ]),
       validateCinemaSpecificRefund(cinema_id) {
        let status = true;
        let user_cinema_id = this.secureStore.get("USINFO").cinema_id;
        if(this.ALLOW_CINEMA_SPECIFIC_REFUND_ONLY == 'Y') {
          if(cinema_id == user_cinema_id) {
            status = true;
          } else {
            status = false;
          }
        } else {
          status = true;
        }
        return status
      },
      onChangeStockReload(event, type, Itemindex, ci_index = null) {
        if(type == 'combo' && ci_index) {
          this.SelectedFnbItem[Itemindex].combo_data[ci_index].reload_stock = event;
        } else {
          this.SelectedFnbItem[Itemindex].reload_stock = event;
        }
      },
      onCheckAuthentication(response) {
        const { valid, name } = response;
        if (valid) {
          if (name == "posFnbRefund") {
            this.noAuth = true;
            this.show2();
            this.$bvModal.hide("authManager_posFnbRefund");
          }
        }
      },
      onPrintHandler: function(isReprint = false) {
        if (this.checkPrintAvailable) {
          const { user_id, cinema_id } = this.secureStore.get("USINFO");
          let payload = {
            OrderCode: this.order_id,
            Type: "Print",
            UserID: user_id,
            isReprint: this.isReprint,
            isRefund: true,
          };

          var userAgent = navigator.userAgent.toLowerCase();
          if (userAgent.indexOf(" electron/") > -1) {
            try {
              if (this.$socket) {
                this.$socket.emit("on_print_ticket", {
                  baseurl: BASEURL,
                  ttype: "fnb-refund",
                  ...payload,
                });

                setTimeout(() => {
                  this.$socket.emit("on_print_ticket", {
                    baseurl: BASEURL,
                    ttype: "fnb-security",
                    OrderCode: this.order_id,
                    UserID: user_id,
                    cinemaId: cinema_id,
                    isReprint: false,
                    extra_query_obj: {
                      isRefund: true,
                    },
                  });
                }, 400);
              }
            } catch (err) {}
          } else {
            let loader = this.$loading.show();
            PosFnbService.GetFnbRefundEjs(payload)
              .then(async (response) => {
                const { data } = response;

                this.EjsData = data;

                this.$nextTick(() => {
                  loader.hide();
                  const p = new Printd();
                  if (this.$refs.onPrint && this.EjsData != null) {
                    p.print(this.$refs.onPrint, []);
                  }
                });
              })
              .catch(this._CatchError);
          }
          this.isReprint = true;
        } else {
          console.log("PRINT ONLY WORK FOR LIMITED SETUPS");
        }
      },
      async onClickInputHandler(event, item = null) {
        if (
          Object.keys(this.keyboardsVisible).some(
            (x) => this.keyboardsVisible[x] == true
          ) ||
          this.SelectedFnbItem.some((y) => y.keyboardActive == true)
        ) {
          let Promises1 = Object.keys(this.keyboardsVisible).map((x) => {
            if (x == event) {
              this.keyboardsVisible[x] = !this.keyboardsVisible[x];
            } else {
              this.keyboardsVisible[x] = false;
            }
          });

          await Promise.all(Promises1);

          let Promises2 = this.SelectedFnbItem.map((y) => {
            y["keyboardActive"] = false;
          });

          await Promise.all(Promises2);

          if (event == "items" && item) {
            this.SelectedFnbItem.map((y) => {
              if (y.item_id == item.item_id) {
                y["keyboardActive"] = !y["keyboardActive"];
              } else {
                y["keyboardActive"] = false;
              }
            });
          }
        }
      },
      onSelectOrder(order) {
        this.order_id = order.order_code;
        this.show2();
      },
      onChangePagination: function(event) {
        if (event === undefined) {
          this.currentPage = 1;
          this.onSearchOrder();
        } else {
          this.currentPage = event;
          this.onSearchOrder();
        }
      },
      onSearchOrder() {
        if (this.searchValue) {
          this.loading = true;
          let payload = {
            limit: this.limit,
            currentPage: this.currentPage,
            searchValue: this.searchValue,
          };

          PosFnbService.SearchFnbOrder(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status && data.Records) {
                this.searchResults = data.Records;
                if (data.totalRow) {
                  this.rows = data.totalRow;
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((err) => {
              console.log("onSearchOrder err", err);
              this.$toasted.show("Something Went Wrong");
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          // this.$toasted.show('Please Enter Valid Order Code')
        }
      },
      handleOnHideModal() {
        console.log(
          "coming handleOnHideModal posRefund",
          this.getCustomerDetails
        );
        if (
          !this.getCustomerDetails ||
          Object.keys(this.getCustomerDetails).length == 0
        ) {
          this.cardSaleType = 1;
        }
      },
      checkPaymentModeValidation() {
        let count = 0;
        let error_msg = "";
        if (this.isCashCardRefund) {
          if (!this.search_ccn) {
            count++;
            this.cc_input_error = "Please Enter Cash Card Number";
          } else if (this.cashCardsList.length == 0) {
            count++;
            error_msg = "No Cash Card Details Found";
            this.$toasted.show(error_msg);
          }
        }
        if (count > 0) {
          return false;
        } else {
          return true;
        }
      },
      checkIsStreetSale(card) {
        if (card && card.hasOwnProperty("customer_id") && card.customer_id) {
          return false;
        } else if (
          card &&
          card.hasOwnProperty("is_guest_user") &&
          card.is_guest_user == "Y"
        ) {
          return false;
        } else if (card && card.is_street_sale == "Y") {
          return true;
        } else {
          return true;
        }
      },
      checkCustomer(card) {
        if (card && card.hasOwnProperty("customer_id") && card.customer_id) {
          return true;
        } else if (
          card &&
          card.hasOwnProperty("is_guest_user") &&
          card.is_guest_user == "Y"
        ) {
          return true;
        } else if (card && card.is_street_sale == "Y") {
          return true;
        } else {
          return false;
        }
      },
      getCardName(card) {
        let name = ``;
        if (card.customer_id) {
          name = `${card.first_name} ${card.last_name ? card.last_name : ""}`;
        } else if (
          card &&
          card.hasOwnProperty("is_guest_user") &&
          card.is_guest_user == "Y"
        ) {
          name = `${card.guest_first_name} ${
            card.guest_last_name ? card.guest_last_name : ""
          }`;
        } else if (card.is_street_sale == "Y") {
          name = `Street Sale`;
        } else {
          name = "-";
        }
        return name;
      },
      onSearchCashCard() {
        this.cc_input_error = "";
        if (this.search_ccn) {
          if (this.search_ccn.replace(/\s/g, "").length !== 12) {
            this.cc_input_error = "Please Enter 12 digit Card Number";
          } else if (isNaN(this.search_ccn.replace(/\s/g, ""))) {
            this.cc_input_error = "Please Enter Valid Cash Card Number";
          } else {
            this.getCashCardDetails();
          }
        } else {
          this.cashCardsList = [];
        }
      },
      getCashCardDetails: function() {
        let loader = this.$loading.show();
        this.cashCardsList = [];
        let payload = {
          perPage: 10,
          currentPage: 1,
          columnName: "",
          orderBy: "created_at",
          searchValue: this.search_ccn,
          filter_is_active: "Y",
        };

        PosService.GetCashCardList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.data.length > 0) {
              this.cashCardsList = data.Records.data;
            } else {
              this.cashCardsList = [];
              this.$toasted.show(this.$t("No Cash Cards Found"));
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      onSelectHandler: function(item) {
        this.RefundReason = item.rr_reason;
        this.refund.rr_id = item.rr_id;
      },
      onSelect(item) {
        this.SelectedFnbItem = item;
      },
      onRemove(item) {},
      onSelectHandlerPayment: function(item, type) {
        if (type == "select") {
          this.selectedPayment = item.pm_payment_mode;
          this.refund_payment_id = item.pm_id;
        } else {
          this.selectedPayment = "";
          this.refund_payment_id = null;
        }
      },
      callClose: function() {
        this.onClickHandler("FnbRefund");
      },
      show1: function() {
        this.section.one = true;
        this.section.two = false;
      },
      show2: function() {
        // this.getRefunds();
        if (this.order_id == "") {
          return this.$toasted.show("Enter Order ID");
        } else if (this.MANAGER_AUTH_FOR_CHANGES == "Y" && !this.noAuth) {
          this.$bvModal.show("authManager_posFnbRefund");
        } else {
          this.fetchPaymentTypesList();
          let payload = {
            order_code: this.order_id,
          };
          let loader = this.$loading.show();
          // this.section.one = false;
          //     this.section.two = true;
          PosService.GetFnbOrderDetails(payload)
            .then((response) => {
              const { data } = response;
              console.log("data", data);
              if (data && data.status) {
                const {cinema_id, cinema_name} = data.Records[0];
                if(this.validateCinemaSpecificRefund(cinema_id)) {
                this.section.one = false;
                this.section.two = true;
                this.card_trx_details = data.Records[0].card_trx_details;
                this.card_payment_gateway =
                  data.Records[0].card_payment_gateway;
                this.orginal_payment_mode = data.Records[0].payment_mode_id;
                this.original_booking_source =
                  data.Records[0].booking_source_id;
                this.curr_code = data.Records[0].hasOwnProperty("curr_code")
                  ? data.Records[0].curr_code
                  : "";
                this.OrderItems = data.Records.filter(
                  (x) => x.refund_datetime == null && x.is_refund == "N"
                ).map((y) => {
                  return { ...y, keyboardActive: false };
                });
                this.SelectedFnbItem = data.Records.filter(
                  (x) => x.refund_datetime == null && x.is_refund == "N"
                ).map((y) => {
                  return { ...y, keyboardActive: false };
                });
                this.AlreadyRefunded = data.Records.filter(
                  (x) => x.refund_datetime != null && x.is_refund == "Y"
                );
                } else {
                  this.$toasted.show(`Refund for this Booking can be avail at ${cinema_name} Branch.`);
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .finally(() => {
              loader.hide();
            });
          // PosService.getRefundReason(payload)
          //   .then((result) => {
          //     const { data } = result;
          //     if (data && data.status && !data.needCinemaManagerLogin) {
          //       this.section.one = false;
          //       this.section.two = true;
          //       this.RefundReason = data.Records[0].rr_reason;
          //       this.seats = data.Records;
          //       this.Selectedseats = data.Records.filter((x) => {
          //         return x.sl_id;
          //       });
          //       this.getPaymentTypesList.map((x) => {
          //         if (x.pm_id == data.Records[0].payment_mode_id) {
          //           this.selectedPayment = x.pm_payment_mode;
          //         }
          //       });
          //       // this.selectedPayment =
          //       this.refund = {
          //         booking_id: this.booking_id,
          //         ...this.refund,
          //         ...data.Records[0],
          //       };
          //       // if (
          //       //   this.refund.booking_status_id == "11" ||
          //       //   this.refund.booking_status_id == "12"
          //       // ) {
          //       //   this.$toasted.show(
          //       //     "You have already applied for refund or you are not eligible for cash refund"
          //       //   );
          //       // }
          //     } else if (!data.status && data.needCinemaManagerLogin) {
          //       this.$refs.cinemaManagerLoginPopup.show();
          //     } else {
          //       this.$toasted.show(data.message);
          //     }
          //   })
          //   .catch(this._CatchError);
        }
      },
      neoPaymentSuccessfull(responseData) {
        //Make Booking
        this.neo_orderRef = "";
        this.neoleapCardDetails["card_refund_details"] = responseData
          ? responseData
          : null;
        this.neoleapCardDetails["nl_card_name"] = responseData.hasOwnProperty(
          "CardNameEnglish"
        )
          ? responseData["CardNameEnglish"]
          : null;
        this.neoleapCardDetails["refund_card_payment_gateway"] = "NEOLEAP";
        this.machineDisplay.processing = false;
        console.log("Refund Processed!");
        this.show3();
      },
      neoPaymentFailed(responseData, message = "") {
        this.machineDisplay.processing = false;
        if (message) {
          this.$toasted.show(message);
        }
      },
      checkNeoLeapStatus(type) {
        this.neoPayType = type;
        this.machineDisplay.processing = true;
        let checkObj = { Command: "CHECK_STATUS" };
        this.requestNeoLeap(JSON.stringify(checkObj));
      },
      retryNeoTransaction() {
        this.neo_retry_count++;
        this.machineDisplay.processing = true;
        let lastTrxObj = { Command: "GET_LAST_TRX" };
        this.requestNeoLeap(JSON.stringify(lastTrxObj));
      },
      proceedNeoleap(type = 1) {
        this.machineDisplay.processing = true;
        let amount = 0;
        this.SelectedFnbItem.forEach((x) => {
          amount = +parseFloat(x.refunded_amount) + amount;
        });
        amount = parseFloat(amount).toFixed(this.MIN_FRACTION_DIGITS);
        if (!isNaN(amount) || amount > 0) {
          this.neo_orderRef =
            this.card_trx_details &&
            this.card_trx_details.hasOwnProperty("ECRReferenceNumber")
              ? this.card_trx_details["ECRReferenceNumber"]
              : generateRandomCode(8);
          let Original_RRN =
            this.card_trx_details &&
            this.card_trx_details.hasOwnProperty("RetrievalReferenceNumber")
              ? this.card_trx_details["RetrievalReferenceNumber"]
              : "";
          let paymentObj = {
            Command: "REFUND",
            Amount: String(amount),
            Original_RRN: Original_RRN,
            MaskedPAN: "",
            PrintFlag: "1",
            AdditionalData: String(this.neo_orderRef),
          };
          this.requestNeoLeap(JSON.stringify(paymentObj));
        } else {
          this.neoPaymentFailed(null, "Please Enter Amount For Refund");
        }
      },
      requestNeoLeap(jsonRequest) {
        if (this.neo_ws.readyState == WebSocket.OPEN) {
          console.log("requestNeoLeap jsonRequest", jsonRequest);
          var res = this.neo_ws.send(jsonRequest);
        } else {
          this.$toasted.show("Connection is Closed " + this.neo_ws.readyState);
        }
      },
      disConnectNeoLeap() {
        this.neo_ws.close();
      },
      createNeoleapWebSocket() {
        let self = this;
        let WS_URL =
          this.NEOLEAP_WEBSOCKET_URL ||
          "wss://localhost:7000/neoleap_integration";
        this.neo_ws = new WebSocket(WS_URL);

        this.neo_ws.onopen = function() {
          // connection opened – add action here
          console.log("Connected");
          self.$toasted.show("Connected");
          setTimeout(() => {
            self.checkNeoLeapStatus(1);
          }, 1000);
        };

        this.neo_ws.onmessage = function(evt) {
          console.log("onmessage evt", evt);
          if (evt.data) {
            let responseData = evt.data ? JSON.parse(evt.data) : "";

            console.log("responseData onmessage", responseData);

            if (
              !responseData.hasOwnProperty("EventName") &&
              !responseData.EventName &&
              responseData.hasOwnProperty("API_Status")
            ) {
              let errorMsg = `FAILED`;
              self.machineDisplay.processing = false;

              if (["2", "6"].includes(String(responseData.API_Status))) {
                if (self.neo_retry_count < 2) {
                  self.retryNeoTransaction();
                } else {
                  switch (responseData.API_Status) {
                    case "2":
                      errorMsg = `NO RESPONSE`;
                      break;
                    case "6":
                      errorMsg = `API TIMEOUT`;
                      break;
                    default:
                      errorMsg = `FAILED`;
                      break;
                  }
                  self.$toasted.show(errorMsg);
                }
              } else {
                switch (responseData.API_Status) {
                  case "3":
                    errorMsg = `PORT ASSIGNED IS NOT PRESENT OR USED BY ANOTHER PROCESS.`;
                    break;
                  case "4":
                    errorMsg = `UNEXPECTED ERROR OCCURRED, REQUEST CANCELLED`;
                    break;
                  default:
                    errorMsg = `FAILED`;
                    break;
                }
                self.$toasted.show(errorMsg);
              }
            } else if (responseData.EventName == "TERMINAL_STATUS") {
              if (responseData.TerminalStatus == "READY") {
                self.proceedNeoleap(responseData);
              } else if (responseData.TerminalStatus == "BUSY") {
                self.neoPaymentFailed(
                  responseData,
                  "Terminal is " + responseData.TerminalStatus
                );
              } else {
                self.neoPaymentFailed(responseData, "Something Went Wring");
              }
            } else if (responseData.EventName == "TERMINAL_RESPONSE") {
              if (responseData.API_Status == "0") {
                if (
                  responseData.hasOwnProperty("JsonResult") &&
                  responseData.JsonResult
                ) {
                  if (
                    responseData.JsonResult.StatusCode == "00" &&
                    responseData.JsonResult.TransactionTypeEnglish ==
                      "REFUND" &&
                    responseData.JsonResult.TransactionResponseEnglish ==
                      "APPROVED"
                  ) {
                    if (
                      responseData.JsonResult.ECRReferenceNumber ==
                      self.neo_orderRef
                    ) {
                      self.$toasted.show(
                        responseData.JsonResult.TransactionResponseEnglish
                      );
                      self.neoPaymentSuccessfull(responseData.JsonResult);
                    } else {
                      self.neoPaymentFailed(
                        responseData,
                        "FAILED, PLEASE TRY AGAIN!"
                      );
                    }
                  } else {
                    self.machineDisplay.processing = false;
                    self.$toasted.show(
                      responseData.JsonResult.TransactionResponseEnglish
                    );
                  }
                } else {
                  self.machineDisplay.processing = false;
                  self.$toasted.show("No Response");
                  // self.retryNeoTransaction()
                }
              } else {
                // self.retryNeoTransaction()
                self.neoPaymentFailed(responseData, "Failed");
              }
            } else if (responseData.EventName == "TERMINAL_ACTION") {
              console.log("SWIPE CARD");
            } else {
              self.machineDisplay.processing = false;
            }
          } else {
            console.log("ELSE evt", evt);
          }
        };
        this.neo_ws.onerror = function(evt) {
          console.log("evt.message onerror", evt.message);
          // error can be determined on evt.message
        };
        this.neo_ws.onclose = function() {
          console.log("Neo Leap Closed");
          // connection closed
        };
      },
      proceedCreditCardRefund() {
        this.$bvModal.show("processessingModal");
        this.createNeoleapWebSocket();
        this.machineDisplay.processing = true;
      },
      checkRefundPayMode(confirmStock = false) {
        if (
          !confirmStock &&
          this.secureStore.get("BRGLOPSTDE") &&
          this.OrderItems.length > 0
        ) {
          this.$bvModal.show("confirmStockDeduction");
        } else if (
          ["2", "3"].includes(String(this.refund_payment_id)) &&
          this.USE_NEOLEAP_POS_PAYMENT == "Y"
        ) {
          this.$bvModal.hide("confirmStockDeduction");
          let refundAmount = 0;
          let count = 0;
          let EmptyAmount = 0;
          this.SelectedFnbItem.forEach((x) => {
            refundAmount = +parseFloat(x.refunded_amount) + refundAmount;
            if (!x.refunded_amount) {
              EmptyAmount++;
            }
            if (x.refunded_amount > x.fp_total_amount) {
              count++;
            }
          });
          if (!this.refund_reason) {
            return this.$toasted.show("Please enter refund reason");
          } else if (!this.refund_payment_id) {
            return this.$toasted.show("Please select refund payment mode");
          } else if (!this.checkPaymentModeValidation()) {
            return;
          } else if (this.SelectedFnbItem.length == 0) {
            return this.$toasted.show("Please select Items For Refund");
          } else if (refundAmount == 0) {
            return this.$toasted.show("Please Enter Amount For Refund");
          } else if (count > 0) {
            return this.$toasted.show(
              "Refund amount must not be greater than Actual Item Cost"
            );
          } else if (EmptyAmount > 0) {
            return this.$toasted.show("Please Enter Refund Amount");
          } else {
            this.proceedCreditCardRefund();
          }
        } else {
          this.$bvModal.hide("confirmStockDeduction");
          this.show3();
        }
      },
      show3: function() {
        if (!this.refund_reason) {
          return this.$toasted.show("Please enter refund reason");
        } else if (!this.refund_payment_id) {
          return this.$toasted.show("Please select refund payment mode");
        } else if (this.SelectedFnbItem.length == 0) {
          this.$toasted.show("Please select Items For Refund");
          return;
        } else if (!this.checkPaymentModeValidation()) {
          return;
        } else {
          let refundAmount = 0;
          this.disableRefundBtn = true;
          this.SelectedFnbItem.forEach((x) => {
            x.refund_reason = this.refund_reason;
            x.refund_payment_mode_id = this.refund_payment_id;
            x.refund_payment_mode_name = this.selectedPayment;
            x.is_refund = "Y";
            refundAmount = +parseFloat(x.refunded_amount) + refundAmount;
          });
          this.mergeByProperty(this.OrderItems, this.SelectedFnbItem, "fst_id");
          console.log("Final Array", this.OrderItems);
          if (this.isCashCardRefund && this.cashCardsList.length > 0) {
            this.cashCardDetails = {
              cash_card_number: this.cashCardsList[0].cash_card_number,
              customer_email: this.cashCardsList[0].cust_email
                ? this.cashCardsList[0].cust_email
                : this.getCustomerDetails
                ? this.getCustomerDetails.cust_email
                : this.CashCardCustEmail
                ? this.CashCardCustEmail
                : this.cashCardsList[0].guest_email
                ? this.cashCardsList[0].guest_email
                : "",
              type: "1",
              isNewCashCard: this.checkCustomer(this.cashCardsList[0])
                ? "N"
                : "Y",
              isStreetSale:
                this.checkIsStreetSale(this.cashCardsList[0]) &&
                this.cardSaleType == 1
                  ? "Y"
                  : "N",
              amount: refundAmount,
              payment_mode_id: 1,
              cash_log_reason: `Refund Order ID - ${this.order_id}`,
              credit_by_refund: "Y",
            };
          }
          let payload = {
            fnbRefundList: this.OrderItems,
            cinema_id: this.cinemaId,
          };
          if (this.isCashCardRefund) {
            payload["cashCardDetails"] = this.cashCardDetails;
          }
          if (
            this.neoleapCardDetails["refund_card_payment_gateway"] == "NEOLEAP"
          ) {
            payload["neoleapCardDetails"] = this.neoleapCardDetails;
          }
          let loader = this.$loading.show();
          PosService.fnbRefund(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.section.three = true;
                this.section.one = false;
                this.section.two = false;
                this.onPrintHandler();
                this.resetCustomerDetails();
                this.MAKE_DATA_EMPTY();
                this.$toasted.show(data.message);
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((err) => {
              console.log("Error: ", err);
            })
            .finally(() => {
              this.disableRefundBtn = false;
              loader.hide();
            });
        }
      },
      mergeByProperty: function(arr1, arr2, prop) {
        _.each(arr2, function(arr2obj) {
          var arr1obj = _.find(arr1, function(arr1obj) {
            return arr1obj[prop] === arr2obj[prop];
          });

          arr1obj ? _.extend(arr1obj, arr2obj) : arr1.push(arr2obj);
        });
      },
      getRefunds: function() {
        let body = {
          tableName: "ms_refund_reasons",
          rr_is_active: "Y",
        };
        MasterService.GetActiveList(body)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.Refunds = data.Records;
            } else
              this.$toasted.show(data.message || "Opps! Something went wrong");
          })
          .catch((error) => {
            this.$toasted.show("Catch Error", error);
          });
      },
      CheckLogin: function() {
        this.submitted = true;
        this.$validator.validate().then((valid) => {
          if (valid) {
            let payload = {
              booking_id: this.booking_id,
              username: this.username,
              password: this.password,
            };
            PosService.CheckCinemaManagerLogin(payload).then((response) => {
              const { data } = response;
              this.username = "";
              this.password = "";
              if (data.status) {
                this.$refs.cinemaManagerLoginPopup.hide();
                this.section.one = false;
                this.section.two = true;
                this.seats = data.Records;
                let OfferDetails = data.offerDetails;
                this.offer_name = OfferDetails.offer_name;
                this.offer_price = OfferDetails.offer_price.toFixed(this.MIN_FRACTION_DIGITS);
                this.voucher_name = OfferDetails.voucher_name;
                this.refund = {
                  booking_id: this.booking_id,
                  ...this.refund,
                  ...data.Records[0],
                };
              } else {
                this.$refs.cinemaManagerLoginPopup.hide();
                this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
              }
            });
          }
        });
      },
    },
  };
</script>
<style>
  .content-fnb-refund {
    height: 500px;
    overflow: auto;
  }

  .invalid_input {
    border: 1px solid red !important;
  }

  .pos-refund-container .fullscreen {
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    z-index: 999;
    height: 100%;
    padding: 16px;
    position: fixed;
    background-color: #fff;
    overflow-y: auto;
  }

  input#searchFnbOrders::placeholder {
    font-style: italic;
    font-size: 13px;
  }

  .tableItem th,
  .tableItem td {
    padding: 4px;
  }

  .tableItem thead tr {
    background: lightgray;
  }

  .input-fnb-order input {
    height: 100%;
    width: 100%;
    border: none;
    display: block;
    padding: 0 15px;
    background-color: white;
    min-height: 40px;
    overflow: hidden;
    border-radius: 10px;
    -webkit-transition: 0.3s ease;
    transition: 0.3s ease;
    border: 1px solid #d3d3d3;
  }

  .disableRefundBtn {
    opacity: 0.5;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/FnbRefund.vue